<!--
================================================
Un composant pour choisir dans une liste de projet.
Inclus dans NewTaskComp et ModalTaskTimerecordsEditionComp

* allowCreateInvite permet de désactiver les liens pour créer un nouveau projet (pour éviter d'ouvrir une modale dans une modale dans ModalTaskTimerecordsEditionComp même si cela semblait fonctionner sans souci)


Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div class="ProjectSelectorComp" v-show="componentIsVisible" v-click-outside="onClickOutside"
       v-bind:class="[{ 'darkMode':themeToDisplay=='dark' }, 'source_'+componentSource]">

        <div class="field filterProject">
            <div class="control has-icons-right">
                <font-awesome-icon class="icon is-right spinnerIcon " :icon="['fas', 'spinner']" spin  v-show="filterIsSubmiting" />

                <input class="input project_selector_filter" v-model="filter" v-validate="'max:80'"
                       name="project_selector_filter" type="text"
                       v-on:keyup="debounceLoadProjects()"
                       v-bind:placeholder="$t('filtrerParProjetClient')"
                       autocomplete="off"
                       v-focus
                >
            </div>

            <div class="noMatch" v-show="filterResults !== null && filterResults==0">
                <span >{{ $t('aucunRésultat') }}</span><br>

                <a class="invitCreation" v-if="allowCreateInvite">
                    <p v-if="noResultWithoutFilter == true" v-on:click="openModalProjectManagement()">
                        {{ $t('créerUnProjet')}}
                    </p>
                    <p class="invitCreateProjectX" v-else v-on:click="openModalProjectManagement(filterNoMatchQuery)">
                        {{ $t('créerUnProjetX', { filter: filterNoMatchQuery }) }}
                    </p>
                </a>
            </div>


        </div>

        <div class="columns">

            <div class="column has-text-left listSelector">

                <!-- on boucle sur la liste de projet groupée par client (name est le nom de la clé de l'objet)-->
                <ul class="clientList" v-for="(value, name, index) in projectsGroupedByClient"
                    v-bind:class="[{ 'filtering':filterIsSubmiting }, 'client_'+index]"
                    v-bind:key="'client'+index">

                        <li v-if="name=='0_client'" class="clientName">
                            <font-awesome-icon class="icon" :icon="['fas', 'user-tie']"/>
                            {{$t('sansClient')}}
                        </li>
                        <li v-else class="clientName">
                            <font-awesome-icon class="icon" :icon="['fas', 'user-tie']"/>
                            {{name}}
                        </li>

                <!-- // liste de projets-->
                    <ul class="projectList" v-for="(project,index) in value" v-bind:key="project.slug">

                        <li v-if="filter==null && index ==0 && name == '0_client'" class="noProjectSelector" v-on:click="selectProject(null)">
                            <font-awesome-icon  class="icon" :icon="['far', 'folder-open']"/>
                            {{$t('aucunProjet')}}
                        </li>

                        <li v-bind:class="'project_'+index + ' project_'+project.slug" v-on:keypress.enter="selectProject(project)" v-on:click="selectProject(project)" tabindex="0" >
                            <font-awesome-icon class="icon" :icon="['far', 'folder-open']" v-bind:style="{color:'#'+project.color}"/>
                            {{project.name}}
                        </li>
                    </ul>
                </ul>

            </div>


        </div>
        <div class="newProjectZone" v-if="allowCreateInvite">
            <a v-on:click="openModalProjectManagement()">
                <font-awesome-icon :icon="['fas', 'plus-circle']" class="icon" />
                {{$t('créerUnProjet')}}</a>
        </div>
    </div>


</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import _ from 'lodash'

    import vClickOutside from 'v-click-outside'


    export default {
        name: 'ProjectSelectorComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification, SentryMixin, InterceptorMixin],
        // components: {},

        directives: {
            clickOutside: vClickOutside.directive,

                /**
                 * Permet de focuser un élément avec v-focus (requiert l'attribut "tabindex" sur la cible)
                 * @link https://vuejs.org/v2/guide/custom-directive.html
                 **/
                focus: {
                    update: function (el) {
                        el.focus()
                    }
                }
        },

        props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            componentSource : String, // Le nom du composant depuis lequel on demande l'ouverture du projectSelectorComp (sert à ouvrir 2 instances du projectSelectorComp : dans la création d'un nouveau pointage ET dans l'édition d'un pointage)
            allowCreateInvite: Boolean, // Si true alors le composant affichera un lien et un bouton pour créer un projet
        },
        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
                ,componentIsVisible : false // Bool indique si le composant est affiché
                ,filter: null //String une chaîne pour rechercher un projet / client
                ,filterIsSubmiting: false      // indique si l'input filter est en cours de soumission
                ,filterResults: null      // integer | le nombre de résultat retournés ATTENTION LES RÉSULTATS SONT GOUPÉS PAR CLIENT -> C'EST DONC DIFFÉRENT DU NOMBRE DE PROJETS !
                ,filterNoMatchQuery: null //String la requête du filtre qui a générée aucun résultat
                ,noResultWithoutFilter : false // Bool vaut true si le chargement des projets ne retourne aucun résultat même sans filtre
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                projectsGroupedByClient: state => state.TimeTrackingView.projectsGroupedByClient,
                themeToDisplay: state =>state.app.themeToDisplay


            }),



        },
        // watch: {},

        methods: {

            /**
             * Gère le masquage du composant lorsque l'on clic en dehors de celui-ci.
             * Basé sur https://www.npmjs.com/package/v-click-outside
             *
             * On ne masque le composant que s'il est actuellement visible et si on n'a pas cliqué sur un élement portant la class .switchProjectSelector_js (car ces éléments servent à ouvrir le composant et il ne s'affiche jamais si on ne les exclue pas).

             **/
            onClickOutside (event) {

              // NOTE : les 2 if suivants contiennent le même code mais j'ai dû distinguer les 2 cas d'ouverture, sinon je ne parvenais pas à afficher le projectSelector dans ModalTaskTimerecordsEditionComp
              if(this.componentSource== "NewTaskComp"){ // quand ProjectSelectorComp est ouvert dans NewTaskComp
                if(this.componentIsVisible == true
                    && !event.target.classList.contains('switchProjectSelector_js')){
                    this.componentIsVisible = false;
                }
              }
              else if(this.componentSource== "ModalTaskTimerecordsEditionComp"){ // quand ProjectSelectorComp est ouvert dans ModalTaskTimerecordsEditionComp
                if(this.componentIsVisible == true
                    && !event.target.classList.contains('switchProjectSelector_js')){
                  this.componentIsVisible = false;

                }
              }

            },

            /**
             * Déclenche this.loadProjects() avec debounce de 300ms.
             */
            debounceLoadProjects:
                _.debounce(
                    function () {
                        this.filterIsSubmiting = true
                        this.loadProjects(this.filter)
                    }, 800),

            /**
             * Récupère les projets accessibles pour l'utilisateur.
             *
             * @param String filter | une chaîne pour filtrer par nom des projets ET clients
             */
            loadProjects(filter){
                let self = this;

              self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.userSlug}/projects`,
                    {
                        params: {
                            filter: filter,
                            archive: 'active' // on exclue les projets archivés
                        },
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on groupe les projects par client
                        let projectsGroupedByClient = _.groupBy(response.data, function (project) {
                            // si pas de client on regroupe dans une clé "0_client"
                            if(project.client == null){
                                return '0_client'
                            }
                            else{ // sinon on groupe dans une clé portant le nom du client
                                return project.client.name
                            }
                        });


                        // on stocke le nombre de résultat
                        self.filterResults = Object.keys(projectsGroupedByClient).length;

                        // si il n'y a aucun résultat même sans filtre
                        if( filter ===undefined && self.filterResults ==0 )
                        { self.noResultWithoutFilter = true}
                        else{self.noResultWithoutFilter = false}

                        // on stocke la dernière requête sans résultat
                        if( self.filterResults === 0) {self.filterNoMatchQuery = filter;}

                        // on réordonne pour avoir la clé "0_client" en premier
                        // @link https://stackoverflow.com/questions/42827133/lodash-sort-list-of-objects-based-on-key
                        let ordered = {};
                        _(projectsGroupedByClient).keys().sort().each(function (key) {
                            ordered[key] = projectsGroupedByClient[key];
                        });

                        // stockage dans le store
                        self.$store.commit('UpdateTimeTrackingViewProjectsGroupedByClient',ordered)

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0025'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id":"0025", "detail": "error fetching projects"})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching projects', 'fatal': false})

                          self.$sentry.captureMessage(`Error 0025 > "error fetching projects : ${error}`, 'error')

                        }
                    })
                    .then(() => {
                        // toujours exécuté
                        self.filterIsSubmiting = false;
                    })
            },

            /**
             * Gère l'affichage/masquage du composant en écoutant l'event 'toggle_project_selector_visibility'
             * @param visibility String ('hide/show')
             * @param source String Le nome du composant depuis lequel on demande l'affichage du ProjectSelectorComp (NewTaskComp et ModalTaskTimerecordsEditionComp)
             *
             */
            toggleVisibility(visibility = null,  source){
              if(this.componentSource==source) {
                if (visibility != null) { // @TODO VISIBILITY NE SEMBLE PAS ETRE UTILISÉ DANS L'APPLI A SUPRIMER ?
                  switch (visibility) {
                    case  'show':
                      this.componentIsVisible = true;
                      this.$root.$emit('hide_tag_selector') // On masque TagSelector au cas où affiché

                      break;
                    case  'hide':
                      this.componentIsVisible = false;

                      break;
                  }
                } else {

                  if (this.componentIsVisible === true) {
                    this.componentIsVisible = false

                  } else {
                    this.componentIsVisible = true
                    this.$root.$emit('hide_tag_selector') // On masque TagSelector au cas où affiché


                  }
                }
              }

            },

            /**
             * Affiche la modal Project Management
             * @param projectName string un nom pour pré-remplir le projet
             */
            openModalProjectManagement(projectName){
                this.filter =null; this.loadProjects(); // on vide le filtre

                // on créé un objet projet avec un attribut name
                let project = {}; project.name = projectName

                this.$root.$emit('show_modal_project_management','creation', project)
            },

          /**
           * Définit le projet sélectionné et propage un event
           * @param project
           */
            selectProject(project){
                this.$root.$emit('project_selected',project, this.componentSource)
                this.componentIsVisible = false
            }


        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')

            // chargement initial des projets
            this.loadProjects()

            // listener de l'event toggle_project_selector_visibility
            this.$root.$on('toggle_project_selector_visibility', (source) => {
              let visibility= null
                // this.toggleVisibility(visibility, source)
                this.toggleVisibility(visibility, source)
            })

          // listener de l'event hide_project_selector
          this.$root.$on('hide_project_selector', (source) => {
            this.componentIsVisible = false;
          })


            // listener de l'event new_project_added,on recharge les projets si un projet est ajouté
            this.$root.$on('new_project_added', () => {
                this.loadProjects()
            })


        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";


    .ProjectSelectorComp{
        padding: 0.1rem 0 0;
        position: absolute;
        margin-top: 3rem;
        width: 28rem;
        /*overflow: auto;*/
        box-shadow: 0 0 5px #999;
        background: white;
        z-index: 39; // pour que les modal Bulma passent par dessus (elles sont à 40)

      &.source_ModalTaskTimerecordsEditionComp{
        // si le composant est ouvert dans la modal tr edit
        position: relative;
        margin-top: 0;
      }

      @include touch{
        position: absolute;
        left: 0.5rem;
        width: auto;
      }

      .filterProject{
        margin: 1.5rem;
        border-bottom:  solid 1px #eee;
        padding-bottom: 1rem;

        .spinnerIcon{
          height: 1.3rem;
          margin-top: 1rem;
          margin-right: 0.5rem;

        }
        .input{
          padding: 1.5rem 1rem ;
          color: $brandThird;
        }
      }

      .clientList{
        padding-bottom: 1rem;

        &.filtering{
          opacity: 0.4;
        }
      }
      .listSelector{
        width: 26rem;
        max-height: 22rem;
        overflow-y: scroll ;
        margin : 0 1rem 1rem;
        padding: 0 1.4rem;

        @include touch{
          margin: 0;
        }


        .clientName{
          /*font-weight: bold;*/
          color :#bbbcba;
          font-size: 0.9rem;
          text-transform: uppercase;
          margin-bottom: 0.5rem;

          .icon{
            margin-right: 0.4rem;
            padding-top: 0.3rem;
          }
        }
        ul.projectList{

          li{
            cursor: pointer;
            margin-bottom: 0.4rem;
            color:#666;
            font-size: 0.95rem;
            font-weight: bold;
            margin-left: 0.5rem;
            padding: 0.3rem 0.7rem;
            border-radius: 0.1rem;
            transition: background-color 0.3s ease-out;

            &:hover{
              background: #f4f4f4;
              color: $projectColor;
              border-radius: 0.2rem;

            }
            &.active{
              /*background: ;*/
              color: $brandBlue;
              font-weight: bold;
            }
            .color {
              display: inline-block;
              height: 10px;
              width: 10px;
              border-radius: 1rem;
              margin-right: 0.3rem;
            }
          }
          .icon{
            padding-top: 0.4rem;
            margin-right: 0.3rem;
          }
        }



      }

      .newProjectZone{
        min-height: 5rem;
        width: 100%;
        background: #f5f5f5;
        color: $brandPrimary;
        box-shadow:   0 -2px  5px  #ccc;

        a{
          color: $brandPrimary;
          text-transform: uppercase;
          font-size: 1rem;
          font-weight: bold;
          height: 100%;
          display: block;
          padding: 2rem 0;


          &:hover{
            color: darken($brandPrimary, 5%);
            background: darken(#f5f5f5, 1%);
            transition:  background-color 200ms;

          }
          .icon{
            font-size: 2.4rem;
          }
        }
      }
      .noMatch{
        margin: 1rem auto 0;
        span{
          color: #999;
        }
        a {
          color: $projectColor !important;
          font-weight: bold;
          &:hover{
            text-decoration: underline;
            color: darken($brandPrimary, 5%)
          }
        }
      }


      /////////////////////////////////////////
      // DARK THEME ///////////////////////////

      &.darkMode{
        //background: darken($darkBg,1%);
        background: $darkBg2;
        box-shadow: 0 0 8px #111;
        border: solid 1px lighten($darkTableTdBg,5%);

        .filterProject{

          border-bottom-color: #555;

          .input{
            background-color: $darkBg !important;
            border-color: $darkFieldBorder !important;
            color: $darkTxt;
            &::placeholder{color:darken($darkTxt,30%)}
            &:focus{
              box-shadow:  0 0 3px $darkContrastTxt inset !important;
            }
          }

        }

        .clientName{color: darken($darkTxt,20%)}

        ul.projectList{
          li{
            color:$darkTxt;
            &:hover {
             background: lighten($darkBg2,5%);
              color:$darkTxt;

            }
          }
        }

        .newProjectZone{
          background: $darkBg;
          box-shadow:   none;

          a{
            color: $brandPrimary;
            &:hover{
              color: darken($brandPrimary, 5%);
              background: lighten($darkBg, 1%);

            }

          }
        }
        .noMatch{
          span{color: #999;}
          a {
            color: $darkBrandBlue !important;
            &:hover{
              color: darken($brandPrimary, 5%)
            }
          }
        }

      }

    }



</style>
